import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';
import { Search } from '../../shared/user.model';
import { UserService } from '../../shared/user.service';
import { ErrorHandler } from '../../shared/ErrorHandler';

@Component({
  selector: 'app-investigation-form',
  templateUrl: './investigation-form.component.html',
  styleUrls: ['./investigation-form.component.css']
})
export class InvestigationFormComponent implements OnInit {

  // constructor() { }
  title = " Investigation Documents";
  itemsPerPage: number = 5;
  currentPage: number = 1;
  InvestigationDetailsList: any = {};
  data: any = {};
  totalItems: number;
  s: Search;
  isSearch: boolean;
  Fir_id: number;
  InvDoc_Id: number;
  FirDetails: any = {};
  Departmentlist: any = {}
  DepartmentDoclist: any = {}
  Investigationdetails: any = {};
  formInvalid: boolean;
  fileToUpload: File;
  p: any = {};
  numericpattern = "^[0-9]*$";
  alphabetpattern = "^[a-zA-Z ]*$";
  alphanumpattern = "^[a-zA-Z0-9 ]*$";
  emailpattern = "^[a-zA-Z0-9._%-+]+@[a-z0-9.-]+\.[a-z]{2,3}$";
  io: any = {};
  i: any = {};
  mode: string;
  dd: any = {};
  ComplainantStatementModel: any = [];
  ComplainantStatement: any = {};
  Investigation: any = {};
  AccusedStatementModel: any = [];
  AccusedStatement: any = {};
  WitnessStatementModel: any = [];
  WitnessStatement: any = {};
  CeasedPropertyFormatModel: any = [];
  CeasedPropertyFormat: any = {};
  DocumentListModel: any = [];
  DocumentList: any = {};
  formSubmitted: boolean;
  CheckList: any = [];
  CheckModel: any = {};
  show: any;
  InvDoc_File: any = null;
  InvDoc_M_File: any = null;
  DocName: any;

  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler) {
    this.s = new Search();
    this.isSearch = false;
    this.formSubmitted = false;
  }

  ngOnInit() {
    this.route.params.subscribe(params =>
      this.Fir_id = params['Fir_id']
    );
    if (this.Fir_id != null)
      this.GetInvestigationForTheId(this.Fir_id);
  }

  GetInvestigationForTheId(Fir_id) {
    debugger;
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.GetInvestigationForTheId(Fir_id)
      .subscribe(
        (data: any) => {
          this.show = "Y";
          this.FirDetails = data;
          this.Investigation = data.InvestigationDocModel;
          if (this.Investigation.InvDoc_M_FileUpload != null)
            this.InvDoc_M_File = this.Investigation.InvDoc_M_FileUpload;
          if (this.Investigation.InvDoc_FileUpload != null)
            this.InvDoc_File = this.Investigation.InvDoc_FileUpload;
          if (this.Investigation.InvDoc_M_Date != null)
            this.Investigation.InvDoc_M_Date = ((this.Investigation.InvDoc_M_Date).split('T'))[0];
          if (this.Investigation.InvDoc_Date != null)
            this.Investigation.InvDoc_Date = ((this.Investigation.InvDoc_Date).split('T'))[0];
          this.AccusedStatementModel = data.InvestigationDocModel.AccusedStatementModel;
          this.ComplainantStatementModel = data.InvestigationDocModel.ComplainantStatementModel;
          this.WitnessStatementModel = data.InvestigationDocModel.WitnessStatementModel;
          this.CeasedPropertyFormatModel = data.InvestigationDocModel.CeasedPropertyFormatModel;
          this.DocumentListModel = data.InvestigationDocModel.DocumentListModel;
          this.GetCheckList(this.FirDetails.InvDoc_Id)
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }

  GetCheckList(InvDoc_Id) {
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.GetCheckList(InvDoc_Id)
      .subscribe(
        (data: any) => {
          this.CheckList = data;
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }

  CreateAccusedStatement(InvDoc_Id: any, form: NgForm) {
    if (!form.invalid) {
      document.getElementById('loader-spinner').style.display = "block";
      form.value.AS_FileUpload = this.getAS_FileUpload();
      this.userService.CreateAccusedStatement(InvDoc_Id, form.value)
        .subscribe(
          (data) => {
            document.getElementById('loader-spinner').style.display = "none";
            this.GetAccusedStatemant(InvDoc_Id)
            form.reset();
            form.resetForm();
            this.formSubmitted = false;
            swal('', 'Accussed Statement Submitted Successfully!', 'success');
          }, (error) => {
            document.getElementById('loader-spinner').style.display = "none";
            this.errorHandler.HandlerError(error);
          });
    } else
      document.getElementById('loader-spinner').style.display = "none";
    this.formSubmitted = true;
  }

  GetAccusedStatemant(InvDoc_Id) {
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.GetAccusedStatemant(InvDoc_Id)
      .subscribe(
        (data: any) => {
          this.AccusedStatementModel = data;
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }

  FileUploadAS(file: FileList) {

    debugger;
    let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;


    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    if (uploadedFilename.match(regex) && (size <= 5048)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      reader.onload = (event: any) => {
        // this.FeasibilityPDFUrl = event.target.result;
      }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response) => {
          // console.log(response);
          // this.app.APP_PA_PhotoErrorMessage="";

        }, (error) => {
          let i: any = document.getElementById('AS_FileUpload');
          i.value = "";
          if (error.status == 400) {
            // this.FeasibilityPDFUrl = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('AS_FileUpload');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload PDF file with extension pdef or pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload image file less than 2mb", 'warning');
    }
  }

  getAS_FileUpload() {
    let imagename = null;
    try {
      imagename = document.getElementById('AS_FileUpload');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }

  DeleteAccusedStatemant(Id, InvDoc_Id) {
    debugger
    if (Id != null) {
      swal({
        title: 'Are you sure?', text: "You want to delete!", type: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          document.getElementById('loader-spinner').style.display = "block";
          this.userService.DeleteAccusedStatemant(Id)
            .subscribe(
              (data) => {
                document.getElementById('loader-spinner').style.display = "none";
                this.GetAccusedStatemant(InvDoc_Id);
                swal('', 'Deleted Successfully!', 'success');

              }, (error) => {
                document.getElementById('loader-spinner').style.display = "none";
                this.errorHandler.HandlerError(error);
              });
        }
      })
    }

  }

  CreateComplainant(InvDoc_Id: any, form: NgForm) {
    debugger;
    if (!form.invalid) {
      document.getElementById('loader-spinner').style.display = "block";
      form.value.CS_FileUpload = this.getCS_FileUpload();
      this.userService.CreateComplainant(InvDoc_Id, form.value)
        .subscribe(
          (data) => {
            document.getElementById('loader-spinner').style.display = "none";
            this.GetComplainantStatement(InvDoc_Id);
            form.reset();
            form.resetForm();
            this.formSubmitted = false;
            swal('', 'Complainant Statement Submitted Successfully!', 'success');
          }, (error) => {
            document.getElementById('loader-spinner').style.display = "none";
            this.errorHandler.HandlerError(error);
          });
    } else
      document.getElementById('loader-spinner').style.display = "none";
    this.formSubmitted = true;
  }

  GetComplainantStatement(InvDoc_Id) {
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.GetComplainantStatement(InvDoc_Id)
      .subscribe(
        (data: any) => {
          this.ComplainantStatementModel = data;
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }

  FileUploadCS(file: FileList) {

    debugger;
    let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;


    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    if (uploadedFilename.match(regex) && (size <= 5048)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      reader.onload = (event: any) => {
        // this.FeasibilityPDFUrl = event.target.result;
      }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response) => {
          // console.log(response);
          // this.app.APP_PA_PhotoErrorMessage="";

        }, (error) => {
          let i: any = document.getElementById('CS_FileUpload');
          i.value = "";
          if (error.status == 400) {
            // this.FeasibilityPDFUrl = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('CS_FileUpload');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload PDF file with extension pdef or pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload image file less than 2mb", 'warning');
    }
  }

  getCS_FileUpload() {
    let imagename = null;
    try {
      imagename = document.getElementById('CS_FileUpload');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }

  DeleteComplainantStatemant(Id, InvDoc_Id) {
    debugger
    if (Id != null) {
      swal({
        title: 'Are you sure?', text: "You want to delete!", type: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          document.getElementById('loader-spinner').style.display = "block";
          this.userService.DeleteComplainantStatemant(Id)
            .subscribe(
              (data) => {
                document.getElementById('loader-spinner').style.display = "none";
                this.GetComplainantStatement(InvDoc_Id);
                swal('', 'Deleted Successfully!', 'success');

              }, (error) => {
                document.getElementById('loader-spinner').style.display = "none";
                this.errorHandler.HandlerError(error);
              });
        }
      })
    }

  }

  CreateWitness(InvDoc_Id: any, form: NgForm) {
    if (!form.invalid) {
      document.getElementById('loader-spinner').style.display = "block";
      form.value.WS_FileUpload = this.getWS_FileUpload();
      this.userService.CreateWitness(InvDoc_Id, form.value)
        .subscribe(
          (data) => {
            document.getElementById('loader-spinner').style.display = "none";
            this.GetWitnessStatement(InvDoc_Id)
            form.reset();
            form.resetForm();
            this.formSubmitted = false;
            swal('', 'Witness Statement Submitted Successfully!', 'success');
          }, (error) => {
            document.getElementById('loader-spinner').style.display = "none";
            this.errorHandler.HandlerError(error);
          });
    } else
      document.getElementById('loader-spinner').style.display = "none";
    this.formSubmitted = true;
  }

  GetWitnessStatement(InvDoc_Id) {
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.GetWitnessStatement(InvDoc_Id)
      .subscribe(
        (data: any) => {
          this.WitnessStatementModel = data;
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }

  FileUploadWS(file: FileList) {

    debugger;
    let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;


    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    if (uploadedFilename.match(regex) && (size <= 5048)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      reader.onload = (event: any) => {
        // this.FeasibilityPDFUrl = event.target.result;
      }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response) => {
          // console.log(response);
          // this.app.APP_PA_PhotoErrorMessage="";

        }, (error) => {
          let i: any = document.getElementById('WS_FileUpload');
          i.value = "";
          if (error.status == 400) {
            // this.FeasibilityPDFUrl = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('WS_FileUpload');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload PDF file with extension pdef or pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload image file less than 2mb", 'warning');
    }
  }

  getWS_FileUpload() {
    let imagename = null;
    try {
      imagename = document.getElementById('WS_FileUpload');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }

  DeleteWitnessStatemant(Id, InvDoc_Id) {
    debugger
    if (Id != null) {
      swal({
        title: 'Are you sure?', text: "You want to delete!", type: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          document.getElementById('loader-spinner').style.display = "block";
          this.userService.DeleteWitnessStatemant(Id)
            .subscribe(
              (data) => {
                document.getElementById('loader-spinner').style.display = "none";
                this.GetWitnessStatement(InvDoc_Id);
                swal('', 'Deleted Successfully!', 'success');

              }, (error) => {
                document.getElementById('loader-spinner').style.display = "none";
                this.errorHandler.HandlerError(error);
              });
        }
      })
    }

  }

  CreateCeasedProperty(InvDoc_Id: any, form: NgForm) {
    if (!form.invalid) {
      document.getElementById('loader-spinner').style.display = "block";
      form.value.CPF_FileUpload = this.getCPF_FileUpload();
      this.userService.CreateCeasedProperty(InvDoc_Id, form.value)
        .subscribe(
          (data) => {
            document.getElementById('loader-spinner').style.display = "none";
            this.GetCeasedPropertyFormat(InvDoc_Id)
            form.reset();
            form.resetForm();
            this.formSubmitted = false;
            swal('', 'Ceased Property Format Submitted Successfully!', 'success');
          }, (error) => {
            document.getElementById('loader-spinner').style.display = "none";
            this.errorHandler.HandlerError(error);
          });
    } else
      document.getElementById('loader-spinner').style.display = "none";
    this.formSubmitted = true;
  }

  GetCeasedPropertyFormat(InvDoc_Id) {
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.GetCeasedPropertyFormat(InvDoc_Id)
      .subscribe(
        (data: any) => {
          this.CeasedPropertyFormatModel = data;
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }

  FileUploadCPF(file: FileList) {

    debugger;
    let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;


    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    if (uploadedFilename.match(regex) && (size <= 5048)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      reader.onload = (event: any) => {
        // this.FeasibilityPDFUrl = event.target.result;
      }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response) => {
          // console.log(response);
          // this.app.APP_PA_PhotoErrorMessage="";

        }, (error) => {
          let i: any = document.getElementById('CPF_FileUpload');
          i.value = "";
          if (error.status == 400) {
            // this.FeasibilityPDFUrl = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('CPF_FileUpload');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload PDF file with extension pdef or pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload image file less than 2mb", 'warning');
    }
  }

  getCPF_FileUpload() {
    let imagename = null;
    try {
      imagename = document.getElementById('CPF_FileUpload');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }

  DeleteCeasedPropertyStatemant(Id, InvDoc_Id) {
    debugger
    if (Id != null) {
      swal({
        title: 'Are you sure?', text: "You want to delete!", type: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          document.getElementById('loader-spinner').style.display = "block";
          this.userService.DeleteCeasedPropertyStatemant(Id)
            .subscribe(
              (data) => {
                document.getElementById('loader-spinner').style.display = "none";
                this.GetCeasedPropertyFormat(InvDoc_Id);
                swal('', 'Deleted Successfully!', 'success');

              }, (error) => {
                document.getElementById('loader-spinner').style.display = "none";
                this.errorHandler.HandlerError(error);
              });
        }
      })
    }

  }

  CreateInvDocument(InvDoc_Id: any, form: NgForm) {
    if (!form.invalid) {
      document.getElementById('loader-spinner').style.display = "block";
      form.value.DocCheck_List_FilePath = this.getDoc_FileUpload();
      this.userService.CreateInvDocument(InvDoc_Id, form.value)
        .subscribe(
          (data) => {
            document.getElementById('loader-spinner').style.display = "none";
            this.GetDocumentList(InvDoc_Id)
            form.reset();
            form.resetForm();
            this.formSubmitted = false;
            swal('', 'Document Submitted Successfully!', 'success');
          }, (error) => {
            document.getElementById('loader-spinner').style.display = "none";
            this.errorHandler.HandlerError(error);
          });
    } else
      document.getElementById('loader-spinner').style.display = "none";
    this.formSubmitted = true;
  }

  GetDocumentList(InvDoc_Id) {
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.GetDocumentList(InvDoc_Id)
      .subscribe(
        (data: any) => {
          this.DocumentListModel = data;
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }

  FileUploadDoc(file: FileList) {

    debugger;
    // let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;


    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    if (size <= 5048) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      reader.onload = (event: any) => {
        // this.FeasibilityPDFUrl = event.target.result;
      }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response) => {
          // console.log(response);
          // this.app.APP_PA_PhotoErrorMessage="";

        }, (error) => {
          let i: any = document.getElementById('DocCheck_List_FilePath');
          i.value = "";
          if (error.status == 400) {
            // this.FeasibilityPDFUrl = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('DocCheck_List_FilePath');
      i.value = "";
      // if (!uploadedFilename.match(regex))
      //   swal('Warning!', "Please upload PDF file with extension pdef or pdf", 'warning');
      if (size > 2048)
        swal('Warning!', "Please upload image file less than 2mb", 'warning');
    }
  }

  getDoc_FileUpload() {
    let imagename = null;
    try {
      imagename = document.getElementById('DocCheck_List_FilePath');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }

  DeleteDocumentList(Id, InvDoc_Id) {
    debugger
    if (Id != null) {
      swal({
        title: 'Are you sure?', text: "You want to delete!", type: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          document.getElementById('loader-spinner').style.display = "block";
          this.userService.DeleteDocumentList(Id)
            .subscribe(
              (data) => {
                document.getElementById('loader-spinner').style.display = "none";
                this.GetDocumentList(InvDoc_Id);
                swal('', 'Deleted Successfully!', 'success');

              }, (error) => {
                document.getElementById('loader-spinner').style.display = "none";
                this.errorHandler.HandlerError(error);
              });
        }
      })
    }

  }

  CreateCheckList(InvDoc_Id: any, CheckData) {
    debugger
    // if (!form.invalid) {
    if (CheckData.CL_Def == 2) {
      CheckData.CL_CaseRelatedInvDocId_Fk = InvDoc_Id;
    }
    else {
      CheckData.CL_Default = 1;
    }
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.CreateCheckList(InvDoc_Id, CheckData)
      .subscribe(
        (data) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.GetCheckList(InvDoc_Id)

          swal('', 'Document Added Successfully!', 'success');
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
    // } else
    //   document.getElementById('loader-spinner').style.display = "none";
    // this.formSubmitted = true;
  }

  UpdateInvestigation(InvDoc_Id: any, InvestData) {
    debugger;
    InvestData.InvDoc_M_FileUpload = this.getM_FileUpload();
    InvestData.InvDoc_FileUpload = this.getIn_FileUpload();
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.UpdateInvestigation(InvDoc_Id, InvestData)
      .subscribe(
        (data) => {
          this.Investigation = null;
          this.Investigation = {};
          this.InvDoc_File = null;
          this.InvDoc_M_File= null;
          document.getElementById('loader-spinner').style.display = "none";
          this.GetInvestigationForTheId(this.Fir_id);

          swal('', 'Investigation Details Added Successfully!', 'success');
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }

  M_FileUpload(file: FileList) {
    this.show = "N";
    debugger;
    let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;


    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    if (uploadedFilename.match(regex) && (size <= 5048)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      reader.onload = (event: any) => {
        // this.FeasibilityPDFUrl = event.target.result;
      }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response) => {
          // console.log(response);
          // this.app.APP_PA_PhotoErrorMessage="";

        }, (error) => {
          let i: any = document.getElementById('InvDoc_M_FileUpload');
          i.value = "";
          if (error.status == 400) {
            // this.FeasibilityPDFUrl = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('InvDoc_M_FileUpload');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload PDF file with extension pdef or pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload image file less than 2mb", 'warning');
    }
  }

  getM_FileUpload() {
    let imagename = null;
    try {
      imagename = document.getElementById('InvDoc_M_FileUpload');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }

  Inv_FileUpload(file: FileList) {
    this.show = "N";
    debugger;
    let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;


    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    if (uploadedFilename.match(regex) && (size <= 5048)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      reader.onload = (event: any) => {
        // this.FeasibilityPDFUrl = event.target.result;
      }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response) => {
          // console.log(response);
          // this.app.APP_PA_PhotoErrorMessage="";

        }, (error) => {
          let i: any = document.getElementById('InvDoc_FileUpload');
          i.value = "";
          if (error.status == 400) {
            // this.FeasibilityPDFUrl = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('InvDoc_FileUpload');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload PDF file with extension pdef or pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload image file less than 2mb", 'warning');
    }
  }

  getIn_FileUpload() {
    let imagename = null;
    try {
      imagename = document.getElementById('InvDoc_FileUpload');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }
  AddChecklistName(ID){
    debugger
    for(let i=0;i<this.CheckList.length;i++)
    {
      if(this.CheckList[i].CL_Id==ID)
      this.DocName=this.CheckList[i].CL_Name;
    }
    
  }
}




// WEBPACK FOOTER //
// ./src/app/investigationdocs-for-investigation/investigation-form/investigation-form.component.ts